/* --------------------------------------------------------------------------------------
   scanBrowse.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const pdfSettingsPopupComponent = {
  template: require('./pdfSettingsPopup.html'),
  bindings: {
    display: '='
  },
  controllerAs: 'vm',
  controller: class pdfSettingsPopupController {
    /* @ngInject */
    constructor(scanService) {
      this.scanService = scanService
    }
    ok() {
      this.display = false
    }
    cancel() {
      this.display = false
    }
    toggleSearchable() {
      this.scanService.searchable = !this.scanService.searchable
    }
    toggleArchival() {
      this.scanService.archival = !this.scanService.archival
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/components/pdfSettingsPopup.component.js